import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import LoadingSpinner from './LoadingSpinner'

/**
 * Indicador visual de guardado para acciones y pies de modal.
 * Usar junto a una región SavingStatus persistente para anunciar el estado.
 * Puede reutilizarse con otro texto, por ejemplo: "Reasignando...".
 */
export default function SavingIndicator({ label = 'Guardando...', size = 16, color, sx = {} }) {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        color: 'inherit',
        lineHeight: 1,
        whiteSpace: 'nowrap',
        ...sx
      }}
    >
      <LoadingSpinner text="" size={size} color={color} role={null} />
      <Typography
        component="span"
        sx={{
          m: 0,
          color: 'inherit',
          font: 'inherit',
          lineHeight: 'inherit',
          whiteSpace: 'inherit'
        }}
      >
        {label}
      </Typography>
    </Box>
  )
}
